import { IVDMBunkerData } from "./@types";

export const portCallsTabData = {
	scheduleData: [
		{
			portName: "Coral Cove",
			portTags: [{ label: "Last Port Call", color: "gray" }],
			berthName: "-",
			actualEta: "08 Oct",
			eta: "08 Oct",
			etb: "-",
			etd: "08 Oct",
			acutalEtd: "08 Oct",
			opsType: "-",
			opsTypeColor: "grey",
			cargoType: "Freight",
			activityTypes: [{ name: "Cargo Loading" }, { name: "Water Intake" }],
			cargoQty: "-",
			ownersAgent: "-",
		},
		{
			portName: "Harbor of Eldoria",
			portTags: [{ label: "HRA: Gulf of Aden", color: "red" }],
			berthName: "-",
			actualEta: "17 Nov",
			etaType: 1, // Delay
			eta: "16 Nov",
			etaStatus: { label: "Delayed by 16hrs", color: "red" },
			etb: "-",
			etd: "16 Nov",
			actualEtd: "17Nov", // the time at which departure actually happened.
			etdType: 1,
			etdStatus: { label: "Delayed by 16hrs", color: "red" },
			opsType: "-",
			opsTypeColor: "grey",
			cargoType: "Reefer",
			activityTypes: [{ name: "Water Intake" }],
			cargoQty: "-",
			ownersAgent: "-",
		},
		{
			portName: "Sunset Bay",
			portTags: [{ label: "ECA: Baltic Sea", color: "orange" }],
			berthName: "-",
			etaType: -1, // Early
			actualEta: "10 Nov",
			eta: "11 Nov",
			etaStatus: { label: "Early by 24hrs", color: "green" },
			etb: "-",
			etd: "11 Nov",
			actualEtd: "10 Nov",
			etdType: -1,
			etdStatus: { label: "Early by 24hrs", color: "green" },
			opsType: "-",
			opsTypeColor: "grey",
			cargoType: "Furniture",
			activityTypes: [
				{ name: "Crew Change" },
				{ name: "Water Intake" },
				{ name: "Cargo Loading" },
			],
			cargoQty: "-",
			ownersAgent: "-",
		},
		{
			portName: "Coral Cove",
			berthName: "-",
			actualEta: "18 Oct",
			eta: "18 Oct",
			etb: "-",
			etd: "18 Oct",
			opsType: "-",
			opsTypeColor: "grey",
			cargoType: "Clothing",
			activityTypes: [
				{ name: "Terminal Inspection" },
				{ name: "Crew Change" },
				{ name: "Water Intake" },
				{ name: "Cargo Loading" },
			],
			cargoQty: "-",
			ownersAgent: "-",
		},
		{
			portName: "Emerald Port",
			berthName: "-",
			actualEta: "18 Oct",
			eta: "18 Oct",
			etb: "-",
			etd: "18 Oct",
			opsType: "-",
			opsTypeColor: "grey",
			cargoType: "Automotive Parts",
			activityTypes: [
				{ name: "PSC Inspection" },
				{ name: "Terminal Inspection" },
				{ name: "Crew Change" },
				{ name: "Water Intake" },
				{ name: "Cargo Loading" },
			],
			cargoQty: "-",
			ownersAgent: "-",
		},
		{
			portName: "Silver Dock",
			berthName: "-",
			actualEta: "18 Oct",
			eta: "18 Oct",
			etb: "-",
			etd: "18 Oct",
			opsType: "-",
			opsTypeColor: "grey",
			cargoType: "Food Products",
			activityTypes: [
				{ name: "Flag Inspection" },
				{ name: "PSC Inspection" },
				{ name: "Terminal Inspection" },
				{ name: "Crew Change" },
				{ name: "Water Intake" },
				{ name: "Cargo Loading" },
			],
			cargoQty: "-",
			ownersAgent: "-",
		},
		{
			portName: "Azure Quay",
			berthName: "-",
			actualEta: "18 Oct",
			eta: "18 Oct",
			etb: "-",
			etd: "18 Oct",
			opsType: "-",
			opsTypeColor: "grey",
			cargoType: "Food Products",
			activityTypes: [
				{ name: "Surveyor Onboard" },
				{ name: "Flag Inspection" },
				{ name: "PSC Inspection" },
				{ name: "Terminal Inspection" },
				{ name: "Crew Change" },
				{ name: "Water Intake" },
				{ name: "Cargo Loading" },
			],
			cargoQty: "-",
			ownersAgent: "-",
		},
	],
};

// [
// 		{
// 			portName: "Coral Cove",
// 			portTags: [{ label: "Last Port Call", color: "gray" }],
// 			berthName: "Sunset Bay",
// 			actualEta: "08 Oct",
// 			eta: "08 Oct",
// 			etb: "09 Oct",
// 			etd: "08 Oct",
// 			acutalEtd: "08 Oct",
// 			opsType: "L",
// 			opsTypeColor: "yellow",
// 			cargoType: "Freight",
// 			activityTypes: [{ name: "Cargo Loading" }, { name: "Water Intake" }],
// 			cargoQty: 50,
// 			ownersAgent: "Seabreeze Harbor",
// 		},
// 		{
// 			portName: "Harbor of Eldoria",
// 			portTags: [{ label: "HRA: Gulf of Aden", color: "red" }],
// 			berthName: "Sunset Bay",
// 			actualEta: "17 Nov",
// 			etaType: 1, // Delay
// 			eta: "16 Nov",
// 			etaStatus: { label: "Delayed by 16hrs", color: "red" },
// 			etb: "16 Oct",
// 			etd: "16 Nov",
// 			actualEtd: "17Nov", // the time at which departure actually happened.
// 			etdType: 1,
// 			etdStatus: { label: "Delayed by 16hrs", color: "red" },
// 			opsType: "D",
// 			opsTypeColor: "blue",
// 			cargoType: "Reefer",
// 			activityTypes: [{ name: "Water Intake" }],
// 			cargoQty: 100,
// 			ownersAgent: "Sunset Bay",
// 		},
// 		{
// 			portName: "Sunset Bay",
// 			portTags: [{ label: "ECA: Baltic Sea", color: "orange" }],
// 			berthName: "Coral Cove",
// 			etaType: -1, // Early
// 			actualEta: "10 Nov",
// 			eta: "11 Nov",
// 			etaStatus: { label: "Early by 24hrs", color: "green" },
// 			etb: "6 Oct",
// 			etd: "11 Nov",
// 			actualEtd: "10 Nov",
// 			etdType: -1,
// 			etdStatus: { label: "Early by 24hrs", color: "green" },
// 			opsType: "B",
// 			opsTypeColor: "purple",
// 			cargoType: "Furniture",
// 			activityTypes: [
// 				{ name: "Crew Change" },
// 				{ name: "Water Intake" },
// 				{ name: "Cargo Loading" },
// 			],
// 			cargoQty: 1000,
// 			ownersAgent: "Coral Cove",
// 		},
// 		{
// 			portName: "Coral Cove",
// 			berthName: "Emerald Port",
// 			actualEta: "18 Oct",
// 			eta: "18 Oct",
// 			etb: "21 Oct",
// 			etd: "18 Oct",
// 			opsType: "L",
// 			opsTypeColor: "yellow",
// 			cargoType: "Clothing",
// 			activityTypes: [
// 				{ name: "Terminal Inspection" },
// 				{ name: "Crew Change" },
// 				{ name: "Water Intake" },
// 				{ name: "Cargo Loading" },
// 			],
// 			cargoQty: 500,
// 			ownersAgent: "Emerald Port",
// 		},
// 		{
// 			portName: "Emerald Port",
// 			berthName: "Silver Dock",
// 			actualEta: "18 Oct",
// 			eta: "18 Oct",
// 			etb: "7 Oct",
// 			etd: "18 Oct",
// 			opsType: "L",
// 			opsTypeColor: "yellow",
// 			cargoType: "Automotive Parts",
// 			activityTypes: [
// 				{ name: "PSC Inspection" },
// 				{ name: "Terminal Inspection" },
// 				{ name: "Crew Change" },
// 				{ name: "Water Intake" },
// 				{ name: "Cargo Loading" },
// 			],
// 			cargoQty: 200,
// 			ownersAgent: "Silver Dock",
// 		},
// 		{
// 			portName: "Silver Dock",
// 			berthName: "Azure Quay",
// 			actualEta: "18 Oct",
// 			eta: "18 Oct",
// 			etb: "8 Oct",
// 			etd: "18 Oct",
// 			opsType: "D",
// 			opsTypeColor: "blue",
// 			cargoType: "Food Products",
// 			activityTypes: [
// 				{ name: "Flag Inspection" },
// 				{ name: "PSC Inspection" },
// 				{ name: "Terminal Inspection" },
// 				{ name: "Crew Change" },
// 				{ name: "Water Intake" },
// 				{ name: "Cargo Loading" },
// 			],
// 			cargoQty: 150,
// 			ownersAgent: "Azure Quay",
// 		},
// 		{
// 			portName: "Azure Quay",
// 			berthName: "Azure Quay",
// 			actualEta: "18 Oct",
// 			eta: "18 Oct",
// 			etb: "8 Oct",
// 			etd: "18 Oct",
// 			opsType: "D",
// 			opsTypeColor: "blue",
// 			cargoType: "Food Products",
// 			activityTypes: [
// 				{ name: "Surveyor Onboard" },
// 				{ name: "Flag Inspection" },
// 				{ name: "PSC Inspection" },
// 				{ name: "Terminal Inspection" },
// 				{ name: "Crew Change" },
// 				{ name: "Water Intake" },
// 				{ name: "Cargo Loading" },
// 			],
// 			cargoQty: 150,
// 			ownersAgent: "Azure Quay",
// 		},
// 	]

export const loadVDMBunkerTabData: IVDMBunkerData = {
	hfo: [
		{
			tankType: "No.1 HFO storage (S)",
			capacity: "887.00",
			currentVolume: "840.00",
			sulphur: "2.85",
			lastBunkerLocation: "YOSU",
			lastBunkerDate: "07 Nov 24",
			status: "-",
			dateColor: "red", // To be later given color on the basis of logic
		},
		{
			tankType: "No.1 HFO storage (P)",
			capacity: "1038.00",
			currentVolume: "19.10",
			sulphur: "1.53",
			lastBunkerLocation: "Vancouver",
			lastBunkerDate: "02 Jan 25",
			status: "In use",
			dateColor: "green",
		},
		{
			tankType: "No.2 HFO storage (P)",
			capacity: "491.00",
			currentVolume: "129.20",
			sulphur: "1.53",
			lastBunkerLocation: "Vancouver",
			lastBunkerDate: "02 Jan 25",
			status: "In use",
			dateColor: "green",
		},
		{
			tankType: "HFO Settling (P)",
			capacity: "-",
			currentVolume: "38.00",
			sulphur: "1.53",
			lastBunkerLocation: "Vancouver",
			lastBunkerDate: "02 Jan 25",
			status: "In use",
			dateColor: "green",
		},
		{
			tankType: "HFO Service (P)",
			capacity: "-",
			currentVolume: "61.00",
			sulphur: "1.53",
			lastBunkerLocation: "Vancouver",
			lastBunkerDate: "02 Jan 25",
			status: "In use",
			dateColor: "green",
		},
		{
			tankType: "FO Overflow",
			capacity: "-",
			currentVolume: "51.50",
			sulphur: "1.53",
			lastBunkerLocation: "Vancouver",
			lastBunkerDate: "02 Jan 25",
			status: "-",
			dateColor: "green",
		},
	],
	lsmgo: [
		{
			tankType: "No.1 MGO storage (S)",
			capacity: "193.00",
			currentVolume: "56.40",
			sulphur: "0.0005%",
			lastBunkerLocation: "Vancouver",
			lastBunkerDate: "07 Feb 25",
			status: "In use",
			dateColor: "red",
		},
		{
			tankType: "No.2 MGO storage (S)",
			capacity: "273.00",
			currentVolume: "207.00",
			sulphur: "0.0005%",
			lastBunkerLocation: "Vancouver",
			lastBunkerDate: "02 Jan 25",
			status: "-",
			dateColor: "red",
		},
		{
			tankType: "MGO service tank",
			capacity: "36.70",
			currentVolume: "26.80",
			sulphur: "0.0005%",
			lastBunkerLocation: "Vancouver",
			lastBunkerDate: "22 Oct 24",
			status: "In use",
			dateColor: "red",
		},
	],
	ethane: [
		{
			tankType: "Tank 1",
			capacity: 2000,
			cargo: 1520,
			fuelROB: 1520,
			volume: 47,
			tempTop: -121,
			tempMid: -121,
			tempBottom: -121,
			pressure: 1.2,
			density: 450,
			bunkerLoc: "Rotterdam",
			bunkerDate: "07 Feb 25",
			status: "In use",
		},
		{
			tankType: "Tank 2",
			capacity: 1840,
			cargo: 1034,
			fuelROB: 1034,
			volume: 87,
			tempTop: -121,
			tempMid: -121,
			tempBottom: -121,
			pressure: 1.19,
			density: 452,
			bunkerLoc: "Vancouver",
			bunkerDate: "02 Jan 25",
			status: "In use",
		},
		{
			tankType: "Tank 3",
			capacity: 3840,
			cargo: 1034,
			fuelROB: 1034,
			volume: 27,
			tempTop: -121,
			tempMid: -121,
			tempBottom: -121,
			pressure: 1.19,
			density: 452,
			bunkerLoc: "Vancouver",
			bunkerDate: "02 Jan 25",
			status: "In use",
		},
		{
			tankType: "Tank 4",
			capacity: 1840,
			cargo: 1034,
			fuelROB: 1034,
			volume: 73,
			tempTop: -121,
			tempMid: -121,
			tempBottom: -121,
			pressure: 1.19,
			density: 452,
			bunkerLoc: "Vancouver",
			bunkerDate: "02 Jan 25",
			status: "In use",
		},
	],
};

export const vdmVesselStatusData = [
	{
		title: "Currently At",
		subTitle: "Port of Atlantis",
		metricsToShow: [
			{
				label: "Time Zone",
				value: "GMT+5:30",
			},
			{
				label: "Fuel mode",
				value: "HFO",
			},
			{
				label: "State",
				value: "Laden",
			},
		],
		alerts: {
			highPriority: ["Security Level 3", "HRA: Gulf of Aden"],
			lowPriority: ["ECA: Baltic Sea"],
		},
	},
	{
		title: "Cargo",
		subTitle: "Tanker",
		metricsToShow: [
			{
				label: "Grade",
				value: "Brent Crude",
			},
			{
				label: "Quantity",
				value: "100,000 MT",
			},
			{
				label: "Temp",
				value: "55° C",
			},
		],
	},
	{
		title: "Operational Status",
		subTitle: "Manned",
		chartData: [
			{ name: "Stoppages", value: 1, color: "#ff8a65" },
			{ name: "At Sea", value: 18, color: "#81d4fa" },
			{ name: "At Port", value: 3, color: "#81c784" },
			{ name: "At Anchor", value: 2, color: "#ffd54f" },
		],
		metricsToShow: [
			{
				label: "SCR Status",
				value: "ON",
			},
			{
				label: "EGCS Status",
				value: "OFF",
			},
		],
	},
	{
		title: "Navigation",
		subTitle: "Heading 273°",
		metricsToShow: [
			{
				label: "FWD Draft",
				value: "10.50 mtr",
			},
			{
				label: "AFT Draft",
				value: "12.80 mtr",
			},
			{
				label: "SOG",
				value: "11.2 kt",
			},
			{
				label: "STW",
				value: "10.7 kt",
			},
		],
		alerts: {
			info: ["Last 24hrs"],
		},
	},
];

export const vdmFuelConsumptionDistanceCovered = [
	{
		time: "01:00",
		speed: 9,
		hfoDistanceCovered: 38,
		hfoConsumption: 0.39,
		lsmgoDistanceCovered: 7,
		lsmgoConsumption: 0.12,
		lngDistanceCovered: 12,
		lngConsumption: 0.07,
		consumptionLimit: 0.9,
	},
	{
		time: "02:00",
		speed: 8,
		hfoDistanceCovered: 30,
		hfoConsumption: 0.48,
		lsmgoDistanceCovered: 3,
		lsmgoConsumption: 0.03,
		lngDistanceCovered: 9,
		lngConsumption: 0.11,
		consumptionLimit: 0.9,
	},
	{
		time: "03:00",
		speed: 7,
		hfoDistanceCovered: 22,
		hfoConsumption: 0.27,
		lsmgoDistanceCovered: 15,
		lsmgoConsumption: 0.18,
		lngDistanceCovered: 1,
		lngConsumption: 0.02,
		consumptionLimit: 0.9,
	},
	{
		time: "04:00",
		speed: 6,
		hfoDistanceCovered: 25,
		hfoConsumption: 0.19,
		lsmgoDistanceCovered: 0,
		lsmgoConsumption: 0.09,
		lngDistanceCovered: 10,
		lngConsumption: 0.14,
		consumptionLimit: 0.9,
	},
	{
		time: "05:00",
		speed: 5,
		hfoDistanceCovered: 28,
		hfoConsumption: 0.51,
		lsmgoDistanceCovered: 8,
		lsmgoConsumption: 0.01,
		lngDistanceCovered: 5,
		lngConsumption: 0.06,
		consumptionLimit: 0.9,
	},
	{
		time: "06:00",
		speed: 4,
		hfoDistanceCovered: 32,
		hfoConsumption: 0.41,
		lsmgoDistanceCovered: 11,
		lsmgoConsumption: 0.15,
		lngDistanceCovered: 2,
		lngConsumption: 0.09,
		consumptionLimit: 0.9,
	},
	{
		time: "07:00",
		speed: 3,
		hfoDistanceCovered: 33,
		hfoConsumption: 0.33,
		lsmgoDistanceCovered: 6,
		lsmgoConsumption: 0.07,
		lngDistanceCovered: 14,
		lngConsumption: 0.03,
		consumptionLimit: 0.9,
	},
	{
		time: "08:00",
		speed: 2,
		hfoDistanceCovered: 34,
		hfoConsumption: 0.24,
		lsmgoDistanceCovered: 2,
		lsmgoConsumption: 0.11,
		lngDistanceCovered: 8,
		lngConsumption: 0.12,
		consumptionLimit: 0.9,
	},
	{
		time: "09:00",
		speed: 45,
		hfoDistanceCovered: 38,
		hfoConsumption: 0.85,
		lsmgoDistanceCovered: 13,
		lsmgoConsumption: 0.05,
		lngDistanceCovered: 0,
		lngConsumption: 0.08,
		consumptionLimit: 0.9,
	}, // Original point had consumption: 0.95, hfoConsumption can be high
	{
		time: "10:00",
		speed: 2,
		hfoDistanceCovered: 35,
		hfoConsumption: 0.39,
		lsmgoDistanceCovered: 5,
		lsmgoConsumption: 0.19,
		lngDistanceCovered: 11,
		lngConsumption: 0.01,
		consumptionLimit: 0.9,
	},
	{
		time: "11:00",
		speed: 3,
		hfoDistanceCovered: 30,
		hfoConsumption: 0.25,
		lsmgoDistanceCovered: 9,
		lsmgoConsumption: 0.02,
		lngDistanceCovered: 4,
		lngConsumption: 0.15,
		consumptionLimit: 0.9,
	},
	{
		time: "12:00",
		speed: 4,
		hfoDistanceCovered: 22,
		hfoConsumption: 0.17,
		lsmgoDistanceCovered: 1,
		lsmgoConsumption: 0.13,
		lngDistanceCovered: 13,
		lngConsumption: 0.04,
		consumptionLimit: 0.9,
	},
	{
		time: "13:00",
		speed: 5,
		hfoDistanceCovered: 2,
		hfoConsumption: 0.05,
		lsmgoDistanceCovered: 10,
		lsmgoConsumption: 0.06,
		lngDistanceCovered: 6,
		lngConsumption: 0.1,
		consumptionLimit: 0.9,
	},
	{
		time: "14:00",
		speed: 6,
		hfoDistanceCovered: 20,
		hfoConsumption: 0.05,
		lsmgoDistanceCovered: 4,
		lsmgoConsumption: 0.17,
		lngDistanceCovered: 1,
		lngConsumption: 0.05,
		consumptionLimit: 0.9,
	},
	{
		time: "15:00",
		speed: 7,
		hfoDistanceCovered: 28,
		hfoConsumption: 0.12,
		lsmgoDistanceCovered: 12,
		lsmgoConsumption: 0.08,
		lngDistanceCovered: 9,
		lngConsumption: 0.13,
		consumptionLimit: 0.9,
	},
	{
		time: "16:00",
		speed: 8,
		hfoDistanceCovered: 35,
		hfoConsumption: 0.32,
		lsmgoDistanceCovered: 7,
		lsmgoConsumption: 0.14,
		lngDistanceCovered: 3,
		lngConsumption: 0.02,
		consumptionLimit: 0.9,
	},
	{
		time: "17:00",
		speed: 9,
		hfoDistanceCovered: 32,
		hfoConsumption: 0.45,
		lsmgoDistanceCovered: 0,
		lsmgoConsumption: 0.04,
		lngDistanceCovered: 15,
		lngConsumption: 0.09,
		consumptionLimit: 0.9,
	},
	{
		time: "18:00",
		speed: 8,
		hfoDistanceCovered: 30,
		hfoConsumption: 0.58,
		lsmgoDistanceCovered: 14,
		lsmgoConsumption: 0.16,
		lngDistanceCovered: 2,
		lngConsumption: 0.07,
		consumptionLimit: 0.9,
	},
	{
		time: "19:00",
		speed: 7,
		hfoDistanceCovered: 28,
		hfoConsumption: 0.39,
		lsmgoDistanceCovered: 8,
		lsmgoConsumption: 0.09,
		lngDistanceCovered: 10,
		lngConsumption: 0.11,
		consumptionLimit: 0.9,
	},
	{
		time: "20:00",
		speed: 6,
		hfoDistanceCovered: 33,
		hfoConsumption: 0.29,
		lsmgoDistanceCovered: 3,
		lsmgoConsumption: 0.1,
		lngDistanceCovered: 7,
		lngConsumption: 0.03,
		consumptionLimit: 0.9,
	},
	{
		time: "21:00",
		speed: 5,
		hfoDistanceCovered: 25,
		hfoConsumption: 0.35,
		lsmgoDistanceCovered: 11,
		lsmgoConsumption: 0.15,
		lngDistanceCovered: 5,
		lngConsumption: 0.14,
		consumptionLimit: 0.9,
	},
	{
		time: "22:00",
		speed: 4,
		hfoDistanceCovered: 35,
		hfoConsumption: 0.19,
		lsmgoDistanceCovered: 6,
		lsmgoConsumption: 0.06,
		lngDistanceCovered: 0,
		lngConsumption: 0.06,
		consumptionLimit: 0.9,
	},
	{
		time: "23:00",
		speed: 3,
		hfoDistanceCovered: 28,
		hfoConsumption: 0.63,
		lsmgoDistanceCovered: 1,
		lsmgoConsumption: 0.12,
		lngDistanceCovered: 13,
		lngConsumption: 0.01,
		consumptionLimit: 0.9,
	},
	{
		time: "24:00",
		speed: 2,
		hfoDistanceCovered: 20,
		hfoConsumption: 0.49,
		lsmgoDistanceCovered: 9,
		lsmgoConsumption: 0.03,
		lngDistanceCovered: 4,
		lngConsumption: 0.1,
		consumptionLimit: 0.9,
	},
];

export const draftSpeedImpactOnFuelConsumptionData = [
	{
		date: "2Mar",
		hfoKgNm: 91.45,
		hfoDraftM: 8.98,
		hfoSogKnots: 11.5,
		lsmgoKgNm: 91.95,
		lsmgoDraftM: 8.93,
		lsmgoSogKnots: 11.55,
		lngKgNm: 90.75,
		lngDraftM: 9.04,
		lngSogKnots: 11.44,
	},
	{
		date: "3Mar",
		hfoKgNm: 93.75,
		hfoDraftM: 8.17,
		hfoSogKnots: 11.41,
		lsmgoKgNm: 92.95,
		lsmgoDraftM: 8.24,
		lsmgoSogKnots: 11.33,
		lngKgNm: 94.7,
		lngDraftM: 8.1,
		lngSogKnots: 11.5,
	},
	{
		date: "4Mar",
		hfoKgNm: 87.97,
		hfoDraftM: 9.36,
		hfoSogKnots: 11.15,
		lsmgoKgNm: 89.07,
		lsmgoDraftM: 9.27,
		lsmgoSogKnots: 11.26,
		lngKgNm: 86.77,
		lngDraftM: 9.45,
		lngSogKnots: 11.04,
	},
	{
		date: "5Mar",
		hfoKgNm: 88.91,
		hfoDraftM: 8.71,
		hfoSogKnots: 11.35,
		lsmgoKgNm: 87.51,
		lsmgoDraftM: 8.82,
		lsmgoSogKnots: 11.21,
		lngKgNm: 90.36,
		lngDraftM: 8.61,
		lngSogKnots: 11.48,
	},
	{
		date: "6Mar",
		hfoKgNm: 91.03,
		hfoDraftM: 8.47,
		hfoSogKnots: 11.19,
		lsmgoKgNm: 91.53,
		lsmgoDraftM: 8.42,
		lsmgoSogKnots: 11.24,
		lngKgNm: 90.33,
		lngDraftM: 8.53,
		lngSogKnots: 11.13,
	},
	{
		date: "7Mar",
		hfoKgNm: 94.29,
		hfoDraftM: 8.02,
		hfoSogKnots: 10.75,
		lsmgoKgNm: 93.49,
		lsmgoDraftM: 8.09,
		lsmgoSogKnots: 10.67,
		lngKgNm: 95.24,
		lngDraftM: 7.94,
		lngSogKnots: 10.84,
	},
	{
		date: "8Mar",
		hfoKgNm: 95.11,
		hfoDraftM: 9.16,
		hfoSogKnots: 11.09,
		lsmgoKgNm: 96.21,
		lsmgoDraftM: 9.07,
		lsmgoSogKnots: 11.2,
		lngKgNm: 93.91,
		lngDraftM: 9.25,
		lngSogKnots: 10.98,
	},
	{
		date: "9Mar",
		hfoKgNm: 91.19,
		hfoDraftM: 8.36,
		hfoSogKnots: 11.29,
		lsmgoKgNm: 89.79,
		lsmgoDraftM: 8.47,
		lsmgoSogKnots: 11.15,
		lngKgNm: 92.64,
		lngDraftM: 8.25,
		lngSogKnots: 11.42,
	},
	{
		date: "10Mar",
		hfoKgNm: 94.37,
		hfoDraftM: 8.44,
		hfoSogKnots: 11.17,
		lsmgoKgNm: 94.87,
		lsmgoDraftM: 8.39,
		lsmgoSogKnots: 11.22,
		lngKgNm: 93.67,
		lngDraftM: 8.5,
		lngSogKnots: 11.11,
	},
	{
		date: "11Mar",
		hfoKgNm: 93.07,
		hfoDraftM: 9.11,
		hfoSogKnots: 11.5,
		lsmgoKgNm: 92.27,
		lsmgoDraftM: 9.18,
		lsmgoSogKnots: 11.42,
		lngKgNm: 94.02,
		lngDraftM: 9.04,
		lngSogKnots: 11.59,
	},
	{
		date: "12Mar",
		hfoKgNm: 91.72,
		hfoDraftM: 8.79,
		hfoSogKnots: 11.7,
		lsmgoKgNm: 92.82,
		lsmgoDraftM: 8.7,
		lsmgoSogKnots: 11.81,
		lngKgNm: 90.52,
		lngDraftM: 8.88,
		lngSogKnots: 11.59,
	},
	{
		date: "13Mar",
		hfoKgNm: 94.17,
		hfoDraftM: 7.82,
		hfoSogKnots: 11.91,
		lsmgoKgNm: 92.77,
		lsmgoDraftM: 7.93,
		lsmgoSogKnots: 11.77,
		lngKgNm: 95.62,
		lngDraftM: 7.71,
		lngSogKnots: 12.04,
	},
	{
		date: "14Mar",
		hfoKgNm: 93.72,
		hfoDraftM: 8.84,
		hfoSogKnots: 11.78,
		lsmgoKgNm: 94.22,
		lsmgoDraftM: 8.79,
		lsmgoSogKnots: 11.83,
		lngKgNm: 93.02,
		lngDraftM: 8.9,
		lngSogKnots: 11.72,
	},
	{
		date: "15Mar",
		hfoKgNm: 93.92,
		hfoDraftM: 9.2,
		hfoSogKnots: 11.52,
		lsmgoKgNm: 93.12,
		lsmgoDraftM: 9.27,
		lsmgoSogKnots: 11.44,
		lngKgNm: 94.87,
		lngDraftM: 9.12,
		lngSogKnots: 11.61,
	},
	{
		date: "16Mar",
		hfoKgNm: 90.07,
		hfoDraftM: 9.57,
		hfoSogKnots: 11.86,
		lsmgoKgNm: 91.17,
		lsmgoDraftM: 9.48,
		lsmgoSogKnots: 11.97,
		lngKgNm: 88.87,
		lngDraftM: 9.66,
		lngSogKnots: 11.75,
	},
	{
		date: "17Mar",
		hfoKgNm: 86.19,
		hfoDraftM: 9.0,
		hfoSogKnots: 12.15,
		lsmgoKgNm: 84.79,
		lsmgoDraftM: 9.11,
		lsmgoSogKnots: 12.01,
		lngKgNm: 87.64,
		lngDraftM: 8.89,
		lngSogKnots: 12.29,
	},
	{
		date: "18Mar",
		hfoKgNm: 87.96,
		hfoDraftM: 9.05,
		hfoSogKnots: 11.69,
		lsmgoKgNm: 88.46,
		lsmgoDraftM: 9.0,
		lsmgoSogKnots: 11.74,
		lngKgNm: 87.26,
		lngDraftM: 9.11,
		lngSogKnots: 11.63,
	},
	{
		date: "19Mar",
		hfoKgNm: 91.09,
		hfoDraftM: 9.24,
		hfoSogKnots: 11.12,
		lsmgoKgNm: 90.29,
		lsmgoDraftM: 9.31,
		lsmgoSogKnots: 11.04,
		lngKgNm: 92.04,
		lngDraftM: 9.17,
		lngSogKnots: 11.21,
	},
	{
		date: "20Mar",
		hfoKgNm: 91.14,
		hfoDraftM: 8.53,
		hfoSogKnots: 10.65,
		lsmgoKgNm: 92.24,
		lsmgoDraftM: 8.44,
		lsmgoSogKnots: 10.76,
		lngKgNm: 89.94,
		lngDraftM: 8.62,
		lngSogKnots: 10.54,
	},
	{
		date: "21Mar",
		hfoKgNm: 86.98,
		hfoDraftM: 10.4,
		hfoSogKnots: 11.31,
		lsmgoKgNm: 85.58,
		lsmgoDraftM: 10.51,
		lsmgoSogKnots: 11.17,
		lngKgNm: 88.43,
		lngDraftM: 10.29,
		lngSogKnots: 11.45,
	},
	{
		date: "22Mar",
		hfoKgNm: 87.99,
		hfoDraftM: 9.74,
		hfoSogKnots: 11.53,
		lsmgoKgNm: 88.49,
		lsmgoDraftM: 9.69,
		lsmgoSogKnots: 11.58,
		lngKgNm: 87.29,
		lngDraftM: 9.8,
		lngSogKnots: 11.47,
	},
	{
		date: "23Mar",
		hfoKgNm: 91.12,
		hfoDraftM: 9.24,
		hfoSogKnots: 11.93,
		lsmgoKgNm: 90.32,
		lsmgoDraftM: 9.31,
		lsmgoSogKnots: 11.85,
		lngKgNm: 92.07,
		lngDraftM: 9.17,
		lngSogKnots: 12.02,
	},
];

export const vdmConsumptionTabData = {
	tabType: "consumption",
	fuelConsumptionBreakdown: {
		title: "Fuel Consumption Breakdown",
		columns: [
			"Fuel type",
			"Daily Consumption",
			"Daily Consumption limit",
			"Total Consumption",
			"ROB",
		],
		rows: [
			{
				fuelType: "HFO",
				consumption: "10 MT",
				consumptionLimit: "12 MT",
				totalConsumption: "-",
				// totalConsumption: "120 MT",
				rob: "100 MT",
			},
			{
				fuelType: "LSMGO",
				consumption: {
					value: "14 MT",
					status: {
						type: "error",
						message: "breached",
					},
				},
				consumptionLimit: "10 MT",
				totalConsumption: "-",
				// totalConsumption: "80 MT",
				rob: {
					value: "50 MT",
					status: {
						type: "error",
						message: "breached",
					},
				},
			},
			{
				fuelType: "LNG",
				consumption: "8 m3",
				consumptionLimit: "10 m3",
				totalConsumption: "-",
				// totalConsumption: "60 m3",
				rob: "150 m3",
			},
		],
	},
	fuelConsumptionByEquipmentType: {
		title: "Fuel Consumption by Equipment Type",
		columns: ["Equipment type", "Fuel type", "Daily Consumption"],
		rows: [
			{
				equipmentType: "Main Engine",
				fuelType: "HFO",
				dailyConsumption: "6 MT",
			},
			{
				equipmentType: "Auxiliary Engine 1",
				fuelType: "LSMGO",
				dailyConsumption: "10 MT",
			},
			{
				equipmentType: "Auxiliary Engine 2",
				fuelType: "LNG",
				dailyConsumption: "8 m3",
			},
			{
				equipmentType: "Boiler",
				fuelType: "HFO",
				dailyConsumption: "4 MT",
			},
			{
				equipmentType: "Generator",
				fuelType: "LNG",
				dailyConsumption: "5 m3",
			},
		],
	},
	voyageSummary: [
		{
			title: "Total HFO Consumed",
			value: "800",
			unit: "MT",
			period: "05 Jan 13:00 - 7 Jan 13:00",
		},
		{
			title: "Total LSMGO Consumed",
			value: "800",
			unit: "MT",
			period: "05 Jan 13:00 - 7 Jan 13:00",
		},
		{
			title: "Total LNG Consumed",
			value: "800",
			unit: "MT",
			period: "05 Jan 13:00 - 7 Jan 13:00",
		},
		{
			title: "Average Speed",
			value: "24",
			unit: "KT",
			period: "06 Jan 13:00 - 7 Jan 13:00",
		},
		{
			title: "Fuel Efficiency",
			value: "92",
			unit: "kg/Nm",
			period: "06 Jan 13:00 - 7 Jan 13:00",
		},
		{
			title: "Distance Covered",
			value: "360",
			unit: "NM",
			period: "05 Jan 13:00 - 7 Jan 13:00",
		},
	],
};

export const vdmSmartAlertsData = {
	smartAlerts: [
		{
			title: "Alert 001",
			value: 2000,
			percentageChange: 20,
			chartData: [
				{ value: 100 },
				{ value: 300 },
				{ value: 200 },
				{ value: 400 },
				{ value: 500 },
			],
			change: "UPWARDS",
			actionLink: "",
		},
		{
			title: "Alert 002",
			value: 3000,
			percentageChange: 10,
			chartData: [
				{ value: 500 },
				{ value: 300 },
				{ value: 300 },
				{ value: 400 },
				{ value: 100 },
			],
			change: "DOWNWARDS",
			actionLink: "",
		},
		{
			title: "Alert 003",
			value: 1500,
			percentageChange: -5,
			chartData: [
				{ value: 250 },
				{ value: 200 },
				{ value: 350 },
				{ value: 300 },
				{ value: 400 },
			],
			change: "DOWNWARDS",
			actionLink: "",
		},
	],
};
